import { schema } from 'normalizr';

const unitSchema = new schema.Entity('units');

export default unitSchema;
